var createSequentialId = function createSequentialId(prefix) {
  var id = 0;
  return function () {
    id += 1;
    return "".concat(prefix).concat(id);
  };
};

export default createSequentialId;
//# sourceMappingURL=create-sequential-id.js.map
